import { ASSET_REDIRECT_TARGET } from "projects/sso/src/app/data";

export const environment = {
    e2e: false,
    production: true,
    firebase: {
        apiKey: "AIzaSyB97KbJQbHTlUOqdPnN2Y6WLmqiSYt81jU",
        authDomain: "dcsptest-sso.service.deloitte.ai",
        projectId: "dcsptest",
    },
    region: "ToDOToBeDeleted",
    brain_base_url: "https://deloitte-test.apigee.net/cwl-dev",
    authParams: ["oidc.azure"],
    signInType: 'signInWithPopup',
    aoh_url: "https://aoh-test.cwl-dev.deloittecampfire.com",
    store_url: "https://store-test.cwl-dev.deloittecampfire.com",
    api_base_url: "https://deloitte-test.apigee.net",
    hasEnterpriseAssetSearch: false,
    asset_redirect_uri: {},
    useBilling: true,
    upload: {
        allowUnclassifiedFilesUpload: true,
        confidentialMetadata: [],
        existingMetadata: []
    },
    onboarding: {
        displayVideo: true,
        video_url: "https://storage.googleapis.com/dcsp-catalog-assets-/data/products/Deloitte%20AI%20Video/Deloitte%20AI%20-%20Asset%20Owner%20Hub.mp4",
        development: {
            frontend_url: "https://storage.googleapis.com/dcsp-catalog-assets-public/data/products/Frontend_Development_Kit/Deloitte.AI%20Frontend%20Development%20Kit.pdf",
            backend_url: "https://bitbucket.de.deloitte.com/projects/AI/repos/dcsp-python-framework/browse",
            business_support_email: "mailto:GlobalDeloitteAi@deloitte.com?subject=Question%20regarding%20Deloitte%20AI%20Marketplace",
        }
    },
    barrierQuestionsAbort: {
        mailAddress: "mahorst@deloitte.de"
    },
    support: {
        ccEmail: "",
        contact: "mailto:GlobalDeloitteAi@deloitte.com?subject=Question%20regarding%20Deloitte%20AI%20Marketplace"
    },
    onboarding_options: {
        "gen_ai": {
            api_url: "https://dev-geniusai.connect-test.api.deloitte.ai",
            app_url: "https://geniusai.cwl-dev.deloittecampfire.com/workflow-selector"
        },
        "manual": {},
        "api_passthrough": {
            authTypes: [
                { label: 'service_owner.technical.self_service.api_key', value: 'api_key' },
                { label: 'service_owner.technical.self_service.token_based_auth', value: 'bearer_token' }
            ],
            onboarding_manager: "mailto:GlobalDeloitteAi@deloitte.com?subject=API%20Onboarding%20I%20Ready%20for%20review"
        },
        "soft_onboarding": {}
    }
};

/**
 * declare asset redirect uri's we use a enum for that so we could not
 * misspell it anymore and auto suggest will work
 */
environment.asset_redirect_uri[ASSET_REDIRECT_TARGET.SCIENTRIX] = "https://scientrix-test.service.deloitte.ai/login";
environment.asset_redirect_uri[ASSET_REDIRECT_TARGET.DPREDICT] = "https://dpredict-test.service.deloitte.ai/login";


// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import "zone.js/plugins/zone-error";  // Included with Angular CLI.
